module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/254-nato-6fb62cc61dbdfc67a9bb754a37dbd222.svg";